module.exports = __webpack_public_path__ + "static/img/zhinengfuwu.3b1d835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/zhinengfuwu.jpg
// module id = vFAf
// module chunks = 7